import { useAuth } from 'oidc-react';

export const useGetAccessToken = (): string => {
  const { userData } = useAuth();

  return userData?.access_token || '';
};
